import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const postContacts = ({ first_name, last_name, email, reason }) => ({ type: "POST_CONTACTS", first_name, last_name, email, reason })
export const postContactsRequest = () => ({ type: "POST_CONTACTS_REQUEST" })
export const postContactsSuccess = payload => ({ type: "POST_CONTACTS_SUCCESS", payload })
export const postContactsFailed = error => ({ type: "POST_CONTACTS_FAILED", error })

export function* postContactsSaga({ 
    first_name, last_name, email, reason
}) {
    yield put(postContactsRequest())
    // alert(JSON.stringify({first_name, last_name, email, reason}))
    try {
        let { data: payload } = 
            yield call(axios,{ 
                data: { first_name, last_name, email, reason }, 
                url: "/contacts", 
                method: "post" 
            })
        yield put(postContactsSuccess(payload))
    } catch(err){
        yield put(postContactsFailed(err))
    }
}

export default function* contactsSagaWatcher() {
    yield takeEvery("POST_CONTACTS", postContactsSaga)
}